/* Instruments */
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "../../../helper/url_helper";
import { get, post } from "../../../helper/api_helper";
import { generateSignature, showToast } from "../../../helper/common";
import { authSlice } from "../auth/slice";
import { socket } from "../../../utils/socket";
import { getValuesSocketData } from "../../../helper/secretManager";

export const getSettings = createAsyncThunk(
  "getSettings",
  async ({ data, callBack }, Thunk) => {
    try {
      const { signature, nonce } = await getValuesSocketData(true);
      const response = await get(URL.GET_SETTINGS, { signature, nonce });
      if (response?.status_code === 405) {
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        Thunk.dispatch(authSlice.actions.clearUserDetails());
        document.cookie = "";
        window.location.reload();
        return Thunk.rejectWithValue(response?.message);
      }
      if (response.status === "failure") {
        showToast(response?.message, "error");
        return Thunk.rejectWithValue(response?.message);
      }
      callBack && callBack(null, response?.data);
      return response.data;
    } catch (error) {
      console.log(error, "<===error");
      callBack && callBack(error);
      return Thunk.rejectWithValue(error);
    }
  }
);

export const addParent = createAsyncThunk(
  "addParent",
  async ({ data, callBack }, Thunk) => {
    try {
      console.info("Calling API to link parent wallet...");
      console.info(data, "DATA");
      const { signature, nonce } = await getValuesSocketData(true);

      const response = await post(URL.ADD_PARENT, data, { signature, nonce });
      console.info(response, "API RES");
      if (response.status_code === 405 || response.status === "failure") {
        console.info("inside::::");
        showToast(response?.message, "error");
        callBack && callBack(response?.message, null);
        return Thunk.rejectWithValue(response?.message);
      }
      showToast(response?.message, "success");
      callBack && callBack(null, response?.data);
      return response.data;
    } catch (error) {
      console.info(error, "<=== API Error");
      showToast("Something went wrong", "error");
      callBack && callBack(error, null); // Fixed missing second argument
      return Thunk.rejectWithValue(error);
    }
  }
);
